$(document).ready(function () {
    var previousActiveTabIndex = 0;

    $(".tab-switcher").on('click keypress', function (event) {
        // event.which === 13 means the "Enter" key is pressed

        if ((event.type === "keypress" && event.which === 13) || event.type === "click") {

            var tabClicked = $(this).data("tab-index");

            if(tabClicked != previousActiveTabIndex) {
              $(".tab-switcher").removeClass("active");
              $(this).addClass("active");
              $("#allTabsContainer .tab-container").each(function () {
                    if($(this).data("tab-index") == tabClicked) {
                        $(".tab-container").hide();
                        $(this).show();
                        previousActiveTabIndex = $(this).data("tab-index");
                        return;
                    }
                });
            }
        }
    });
});

// Retrieve my current url parameters
function getParameter(theParameter) {
  var params = window.location.search.substr(1).split('&');
  for (var i = 0; i < params.length; i++) {
    var p=params[i].split('=');
     if (p[0] == theParameter) {
      return decodeURIComponent(p[1]);
    }
  }
  return false;
}
url_ad_group = getParameter('ad_group');


// I retrieve data from my cookie (if it exists) and I create an object in JavaScript.
var pepites = new Object();
var gads_cookie = Cookies.get('cookie_gads');

// If at least one URL parameter exist AND the cookie doesn't exist
if((url_ad_group!== false) && (gads_cookie == null || gads_cookie == "" )) {
  if(url_ad_group!== false){ 
    pepites["ad_group"] = url_ad_group; 
  }
  Cookies.set('cookie_gads', pepites, { expires: 120 } );
}

// Else if we get at least one URL parameter AND the cookie exist
else if((url_ad_group!== false) && (gads_cookie != null || gads_cookie != "")) {
  gads_cookie_choco = JSON.parse(gads_cookie);

  if(gads_cookie_choco["ad_group"] != undefined) {
    if(url_ad_group!== false && gads_cookie_choco["ad_group"].indexOf(url_ad_group) != -1 ){
      pepites["ad_group"] = gads_cookie_choco["ad_group"]; 
    }
  }                            
  else if ( url_ad_group!== false ) { 
      pepites["ad_group"] = url_ad_group; 
  }

  Cookies.set('cookie_gads', pepites, { expires: 120 } );
}
